// extracted by mini-css-extract-plugin
export default {"button":"ml-z","reviewSort":"nl-z"};